module.exports = __webpack_public_path__ + "4a742c415f352267bc0dae6611aacade.jpg";